module.exports = __webpack_public_path__ + "img/full7-min.f9d9ad0f.png";